import { API_URL } from "commons/constants/env";
import axios from "axios";

const axiosPublicInstance = axios.create({
  baseURL: API_URL,
});

export default axiosPublicInstance;
